var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbBigCirlceIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 59.857,
    viewBox: "0 0 60 59.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FB",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M60,30.111A30,30,0,1,0,25.312,59.857V38.816H17.695v-8.7h7.617V23.478c0-7.547,4.479-11.715,11.331-11.715a45.516,45.516,0,0,1,6.715.594v7.409H39.577c-3.728,0-4.889,2.322-4.889,4.7v5.648h8.319l-1.329,8.7H34.684V59.857A30.085,30.085,0,0,0,60,30.111Z",
    transform: "translate(0 0)",
    fill: "#1877f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbBigCirlceIcon);
export default __webpack_public_path__ + "static/media/fb-big-cirlce-icon.2f186f8e47779d8aabaf37dba6b40964.svg";
export { ForwardRef as ReactComponent };